const sixMonthsFreeTrial = 'prime_6_month_trial_';
const eventCategoryPrefix = sixMonthsFreeTrial;
const eventConstants = {
    eventCategoryPrefix,
    trackingPageLabel: {
        postbooking: 'prime/free-trial-6-months/',
        freePrime: 'prime/free-trial-6-months-no-token/',
    },
    start: 'start',
    register: 'register',
    registerSuccess: 'register-success',
    registerError: 'register-error',
    login: 'login',
    signIn: 'sign-in',
    trackingPageLabelConfig: {
        start: {
            postbooking: {
                mobile: 'start',
                desktop: 'register',
            },
            freePrime: {
                desktop: 'sign-in',
                mobile: 'start',
            },
        },
        register: {
            postbooking: {
                desktop: 'register',
            },
            freePrime: {
                desktop: 'register', // if same in mobile no need to add mobile
            },
        },
        registerSuccess: {
            postbooking: {
                desktop: 'register-success',
            },
            freePrime: {
                desktop: 'register-success',
            },
        },
        registerError: {
            postbooking: {
                desktop: 'resgister-error',
            },
        },
        login: {
            postbooking: {
                desktop: 'login',
            },
        },
        signIn: {
            postbooking: {
                desktop: 'sign-in',
            },
            freePrime: {
                desktop: 'sign-in',
            },
        },
    },
    eventInfoObj: function(isFreePrime, isRegistered, YZB) {
        return {
            start: {
                category: {
                    mobile: eventCategoryPrefix + `start${isFreePrime ? '_np' : ''}`,
                    desktop: eventCategoryPrefix + 'register',
                },
                action: 'prime_free_trial_start',
                label: {
                    register: `start_prime_free_trial_acc:${isRegistered ? '1' : '0'}${isFreePrime ? '_pag:free-start-np' : ''}`,
                    error: `create_prime_account_error${isFreePrime ? '_pag:free-start-np' : ''}`,
                    pwdError: `sso_pwd_pci_compliance_error${isFreePrime ? '_pag:free-start-np' : ''}`,

                },
            },
            register: {
                category: {
                    mobile: isFreePrime ? 'prime_6_month_trial_start_np' : eventCategoryPrefix + 'register',
                    desktop: isFreePrime ? 'prime_6_month_trial_start_np' : eventCategoryPrefix + 'register',
                },
                action: 'prime_registration_form',
                label: {
                    register: isFreePrime ? 'prime_create_account_pag:free-reg-np' : 'create_prime_account',
                    back: isFreePrime ? 'prime_back_pag:free-reg-np' : 'back_prime_register',
                    policy: isFreePrime ? 'prime_policy_pag:free-reg-np' : 'prime_reg_data_protection_policy',
                    terms: isFreePrime ? 'prime_terms_and_conditions_pag:free-reg-np' : 'prime_reg_terms_and_conditions',
                    error: isFreePrime ? 'prime_create_account_error_pag:free-reg-np' : 'create_prime_account_error',
                    pwdError: isFreePrime ? `prime_error_${YZB}_pag:free-reg-np` : 'sso_pwd_pci_compliance_error',
                },
            },
            signin: {
                category: {
                    mobile: eventCategoryPrefix + 'signin',
                    desktop: eventCategoryPrefix + 'register',
                },
                action: isFreePrime ? null : 'prime_signin_form',
                label: {
                    signin: 'signin_prime_account',
                    back: 'back_prime_signin',
                    policy: 'prime_signin_data_protection_policy',
                    terms: 'prime_signin_terms_and_conditions',
                    error: 'signin_prime_account_error',
                },
            },
            login: {
                category: {
                    mobile: eventCategoryPrefix + 'login',
                    desktop: eventCategoryPrefix + 'register',
                },
                action: isFreePrime ? null : 'prime_login_form',
                label: {
                    error: 'login_prime_account_error',
                },
            },
        };
    },
};

const genericConstants = {
    basicMembershipType: 'BASIC',
    basicFreeMembershipType: 'BASIC_FREE',
    sixMonthsToRenewal: '6',
    emailChannel: 'email',
    zeroBalance: '0',
    zeroAmount: 0,
};

module.exports = {
    eventConstants,
    genericConstants,
};
